@for (group of groups(); track group.name) {
  <div class="p-2 text-xs font-bold opacity-75">
    {{ group.name | titlecase }}
    <mat-icon
      class="icon-3 opacity-50"
      matTooltip="Fee Schedules from {{ group.scope | titlecase }}"
      >info</mat-icon
    >
  </div>
  @for (schedule of group.schedules; track schedule.ref.path) {
    <button
      mat-menu-item
      [ngClass]="{
        'current-fee-schedule':
          feeSchedule() | pairMap: schedule : isCurrentFeeSchedule : this
      }"
      (click)="scheduleSelected.emit(schedule)"
    >
      {{ schedule.name }}
    </button>
  }
}
